import { get, post, put } from '../Services/http';
import { catchError } from './Error.action';
export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';
export const MODAL_SERVER_ERROR_MESSAGE = 'MODAL_SERVER_ERROR_MESSAGE';

export const showModel = () => (dispatch) => {
  dispatch({
    type: MODAL_SHOW,
    payload: { showPop: true },
  });
};
export const hideModel = (dispatch) => ({
  type: MODAL_HIDE,
  payload: {
    showPop: false,
  },
});
export const updateServerErrorMessage = (error) => ({
  type: MODAL_SERVER_ERROR_MESSAGE,
  payload: {
    error,
  },
});
export const resetServerErrorMessage = () => ({
  type: MODAL_SERVER_ERROR_MESSAGE,
  payload: {
    error: {},
  },
});

export const updatePassword =
  (oldPassword, password, confirmPassword) => (dispatch, getState) => {
    resetServerErrorMessage();
    return post('/api/resetpassword/update', {
      oldPassword,
      password,
      confirmPassword,
    })
      .then((response) => response.json())
      .then((reset) => {
        dispatch(hideModel());
      })
      .catch((ex) => {
        dispatch(catchError(ex, (error) => updateServerErrorMessage(error)));
      });
  };
